import BulletList from "./SVG/bullet-list.svg?react";

const BulletListIcon = () => {
  return <BulletList />;
};

export default BulletListIcon;
